const Roles = {
  ADMINS: 'Admins',
  FINANCIAL_ADMINS: 'Financial_Admins',
  BU_MANAGERS: 'BU_Managers',
  DEPARTMENT_MANAGERS: 'Department_Managers',
  PORTFOLIO_MANAGERS: 'Portfolio_Managers',
  PRODUCT_MANAGERS: 'Product_Managers'
}

export default Roles
